var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskMed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "risk-med") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tags/Risk-Indicator/Medium",
    transform: "translate(-8.000000, -6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(8.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "risk-med",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFE4AF",
    x: 0,
    y: 7.41176471,
    width: 3.15789474,
    height: 6.58823529,
    rx: 1.57894737
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-31",
    fill: "#FFE4AF",
    x: 3.94789474,
    y: 4.94117647,
    width: 3.15789474,
    height: 9.05882353,
    rx: 1.57894737
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-32",
    fill: "#C9CED7",
    x: 7.89578947,
    y: 2.47058824,
    width: 3.15789474,
    height: 11.5294118,
    rx: 1.57894737
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-44",
    fill: "#C9CED7",
    x: 11.8436842,
    y: 0,
    width: 3.15789474,
    height: 14,
    rx: 1.57894737
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskMed);
export default __webpack_public_path__ + "static/media/risk-med.1f7fcfffe5ac3e8f40c1e345d6840061.svg";
export { ForwardRef as ReactComponent };